import {FetchService} from "dc-services/fetch.service";

export function externalStock() {
    itemlist();
    itemcard();
    quickorder();
    basketStock();
    itembox();
    order();
}

function order() {
    const itemboxes = document.querySelectorAll(".orderItem");
    for(const itembox of itemboxes) {
        const itemno = itembox.dataset.itemno;
        setInventory(itembox, itemno);
    }
}

function itembox() {
    const itemboxes = document.querySelectorAll(".itembox");
    for(const itembox of itemboxes) {
        const itemno = itembox.querySelector(".itembox__itemno").dataset.itemno;
        setInventory(itembox, itemno);
    }
}

export function basketStock() {
    const items = document.querySelectorAll(".itemBasketBox");
    for(const item of items) {
        const itemno = item.dataset.itemno;
        setInventory(item, itemno);
    }
}

function quickorder() {
    const items = document.querySelectorAll(".directOrderItemlistItem");
    for(const item of items) {
        const itemno = item.dataset.itemno;
        setInventory(item, itemno);
    }
}

function itemlist() {
    const forms = document.querySelectorAll("form[data-itemno]");

    for (const form of forms) {
        const itemno = form.dataset.itemno;
        setInventory(form, itemno);
    }
}

function itemcard() {
    const itemcardForm = document.getElementById("itemcard_order_button_form_std");
    const itemno = document.getElementById("beturboItemNo")?.value;
    if(itemcardForm && itemno) {
        setInventory(itemcardForm, itemno);
    }
}

async function setInventory(element, itemno) {
    const inventory = element.querySelector('.inventory');

    if (inventory) {
        const response = await FetchService.get('/em/externalStock/getExternalInventory/' + itemno);

        if(response.success) {
            if(!response.data.native_inventory || response.data.native_inventory == "0.00") {
                if(response.data.inventory) {
                    inventory.classList.add('low_availability');
                    const inventoryCount = response.data.inventory > 4 ? '>4' : response.data.inventory;
                    inventory.querySelector('p').textContent = inventoryCount + ' ' + GLOBALS.tc.external_stocks;
                } else {
                    inventory.classList.add('not_available');
                    inventory.querySelector('p').textContent = GLOBALS.tc.not_available;
                }
            } else {
                const nativeInventory = Math.floor(response.data.native_inventory);
                const inventoryCount = nativeInventory > 4 ? '>4' : nativeInventory;
                inventory.querySelector('p').textContent = inventoryCount +  ' ' + GLOBALS.tc.available;
            }
        }

        inventory.classList.remove("loadSkeleton");

        element.querySelector('.orderButtonWrapper')?.classList.add("is-active");
        element.querySelector('.orderButtonWrapper')?.classList.remove("inactive");
        element.querySelector('.quantity')?.classList.add("is-active");
        element.querySelector('.quantity')?.classList.remove("quantity--inactive");
        element.querySelector('.js-quantity-value')?.removeAttribute('disabled');
        element.querySelector('.js-spinnerUp')?.removeAttribute('disabled');
        element.querySelector('.orderButton')?.classList.remove("disabled");
        element.querySelector('.orderButton')?.removeAttribute('disabled');

    }
}